var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundImageOnboardingscreens1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 721,
    viewBox: "0 0 605 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.164551,
    width: 604.835,
    height: 721,
    fill: "#91268F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.572 545.911C124.092 523.733 195.975 324.38 124.837 244.84C24.1151 149.021 3.54333 141.028 0.164398 145.481C0.164886 150.709 -0.205872 149.728 0.164398 151.21C1.66599 157.218 0.164398 721 0.164398 721H410.731C410.731 682.313 407.122 629.728 361.571 593.936C333.558 571.925 207.148 573.592 175.572 545.911Z",
    fill: "#861D84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M433.158 402.031C530.42 453.106 482.788 426.567 604.659 472.134V6.10352e-05H80.7593C89.2941 10.3707 100.33 20.1826 114.589 28.9807C150.299 51.0132 311.443 49.3441 351.695 77.0516C417.32 99.251 342.474 322.413 433.158 402.031Z",
    fill: "#861D84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImageOnboardingscreens1);
export default __webpack_public_path__ + "static/media/Background_image_onboarding screens (1).e96a241a45e6914a9b236cbb71b02530.svg";
export { ForwardRef as ReactComponent };